export default __webpack_public_path__ + "static/media/logofull.531847e4.png";